document.addEventListener('DOMContentLoaded', function () {

  const scrollTriggers = document.querySelectorAll('.scroll-to-reviews');

  if (scrollTriggers.length > 0) {
    scrollTriggers.forEach(scrollTrigger => {
      scrollTrigger.addEventListener('click', function (e) {
        e.preventDefault();

        // Wait until the Junip reviews widget exists
        const waitForReviews = setInterval(() => {
          const reviewsEl = document.querySelector('.junip-product-review-container');
          if (reviewsEl) {
            clearInterval(waitForReviews);
            reviewsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);

        // Optional: stop checking after 5 seconds
        setTimeout(() => clearInterval(waitForReviews), 5000);
      });
    });
  }
});